module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/desktop_57f7e2.jpg";